/**
 * TanStack Router configuration
 *
 * Creates and exports the router instance for the application.
 * The route tree is auto-generated by the TanStack Router Vite plugin.
 */
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./route-tree.gen";

/**
 * Create the router instance with the generated route tree
 */
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

/**
 * Register the router instance for type safety
 */
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
